module.exports = __webpack_public_path__ + "img/404.d7b80f79.png";